<template lang="pug">
  .component-entities-search.callout
    .row
      .column.small-12.medium-3
        search-input-form(:placeholder="'Client'", @keydown.native="component = null" @filteredSearch="setClientComponent")
      .column.small-12.medium-3
        search-input-form(:placeholder="'Driver'", @keydown.native="component = null" @filteredSearch="setDriverComponent")
      .column.small-12.medium-3
        search-input-form(:placeholder="'Reservation (id or client name)'", @keydown.native="component = null" @filteredSearch="setReservationComponent")
      .column.small-12-medium-3
        search-input-form(placeholder="Vehicle license plate", @keydown.native="component = null" @filteredSearch="setVehicleComponent")

    base-list(v-if="component", :component="component", :dataLoader="dataLoader")
</template>

<script>
import SearchInputForm from 'components/structure/ui/filters/SearchInputForm'
import KeplerBackofficeSdk from "../../lib/kepler/backoffice";
import VehicleListForm from "../structure/ui/filters/VehicleListForm";
import BaseList from "../../pages/backoffice/BaseList";

export default {
  data: function () {
    return {
      component: null,
      search: {
        query: null
      },
    }
  },
  components: {
    BaseList,
    VehicleListForm,
    SearchInputForm
  },
  name: "entities-search",
  methods: {
    setClientComponent(search) {
      this.search.query = search.query
      this.component = require('src/components/backoffice/Client')
    },
    setDriverComponent(search) {
      this.search.query = search.query
      this.component = require('src/components/backoffice/Driver')
    },
    setReservationComponent(search) {
      this.search.query = search.query
      this.component = require('src/components/backoffice/Reservation')
    },
    setVehicleComponent(search) {
      this.search.query = search.query
      this.search.inject_reservation_status = true
      this.component = require('src/components/backoffice/Vehicle')
    },

    dataLoader(callback, page = 1, resultsPerPage = 25) {

      var entity = null
      switch (this.component.name) {
        case 'BackofficeClient':
          entity = 'clients'
          break;
        case 'BackofficeDriver':
          entity = 'drivers';
          break;
        case'BackofficeReservation':
          entity = 'reservations'
          break
        case'Vehicle':
          entity = 'vehicles'
          break
        default:
          console.log(this.component.name)
      }

      return KeplerBackofficeSdk[entity].list(page, resultsPerPage, this.search).search((items) => {
        callback(items)
      })
    }
  }
}
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// EntitiesSearch.vue?535aa157